import { CertificationsEmptyStateContainer, EmptyStateImage, Info } from './styles';
import { useContext } from 'react';
import { SessionContext } from 'contexts/session';
import EmptyStateSvg from 'assets/images/empty-state-certs.svg';
import Button from 'components/button';
import { INE_CONTACT_SALES } from 'constants/settings';

const CertificationsEmptyState = (): JSX.Element => {
  const { account } = useContext(SessionContext);

  const handleContact = () => {
    window.location.href = `mailto:${INE_CONTACT_SALES},${account?.sales_contact?.email}`;
  };

  return (
    <CertificationsEmptyStateContainer>
      <EmptyStateImage src={EmptyStateSvg} alt="Empty State" />
      <Info.Container>
        <Info.Title>Validate your team’s skills with certifications</Info.Title>
        <Info.Text>
          Certifications prove your team is ready to tackle real-world challenges.
          <br /> Track their progress and empower them to showcase their expertise with industry
          recognized certifications.
        </Info.Text>
        <Info.CtaWrapper>
          <Button $primary size="small" onClick={() => handleContact()}>
            Contact INE to get certifications
          </Button>
        </Info.CtaWrapper>
      </Info.Container>
    </CertificationsEmptyStateContainer>
  );
};

export default CertificationsEmptyState;
